import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_1M_29_99_1M_44_EN_CLUSTER',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_1m_29_99_1m_44_usd',
			GBP: 'simple_premium_1m_29_99_1m_44_gbp',
			CAD: 'simple_premium_1m_49_99_1m_45_cad',
			AUD: 'simple_premium_1m_49_99_1m_45_aud',
		},
		primer: 'prd_McBc2ZxFkwv4',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'month',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 30,
		priceMap: {
			USD: 44,
			GBP: 44,
			CAD: 45,
			AUD: 45,
		},
		originalPriceMap: {
			USD: 44,
			GBP: 44,
			CAD: 45,
			AUD: 45,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 29.99,
			GBP: 29.99,
			CAD: 49.99,
			AUD: 49.99,
		},
	},
	options: ($t) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.30_days.into_period_text'), // 'first month'
		explicitTermsIntervalText: $t('pages.program.organic.cheap_and_short.plans.30_days.sub_period_text'), // 'monthly'
		billingSubtitlePeriodText: $t('pages.program.cheap_and_short.plans.30_days.into_period_text'), // 'first month'
		footerPeriodText: $t('pages.program.cheap_and_short.plans.30_days.period_text'), // '1-month'
		footerIntervalText: $t('pages.program.cheap_and_short.plans.30_days.sub_period_text'), // 'monthly'
	}),
}
